import { ItemListPosition } from '@capsicum/common';
import { Image, InfoCard } from '@capsicum/common-web';
import { ChilizChainCircleIcon } from '@capsicum/common-web/icons';
import {
	type NCWConfirmTransferAmountCardProps,
	useNCWConfirmTransferAmountCard
} from '@capsicum/features/nc-wallet/shared';
import styled from 'styled-components';

export const NCWConfirmTransferAmountCard = ({
	assetImageUri,
	assetName,
	formattedAmount,
	isChiliz
}: NCWConfirmTransferAmountCardProps) => {
	const { intlTexts } = useNCWConfirmTransferAmountCard();

	return (
		<S.Price
			icon={
				isChiliz ? (
					<ChilizChainCircleIcon />
				) : (
					<Image alt={assetName} height={24} optimized placeholder="empty" src={assetImageUri} width={24} />
				)
			}
			itemListPosition={ItemListPosition.SOLO}
			mainRightText={formattedAmount ?? ''}
			testID="ncw-transfer-confirmation-amountCard"
			title={intlTexts.amount}
		/>
	);
};

namespace S {
	export const Price = styled(InfoCard)`
		margin-bottom: ${({ theme }) => theme.spacings.xsmall};
	`;
}
